import HttpReaderNode from './types/http-reader';
import HttpV2ReaderNode from './types/http-v2-reader';
import HttpWriterNode from './types/http-writer';
import HttpXmlConnectorNode from './types/http-xml-connector';

export const httpNodes = {
  httpReader: HttpReaderNode,
  httpWriter: HttpWriterNode,
  httpV2Reader: HttpV2ReaderNode,
  httpXmlConnector: HttpXmlConnectorNode,
};
